import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-limit-guide-dialog',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './limit-guide-dialog.component.html',
  styleUrl: './limit-guide-dialog.component.css',
})
export class LimitGuideDialogComponent {

}
